import { TextStyle } from "@pixi/text";
import { FitText } from "./FitText";
import { Localization } from "../Localization";
import { Language } from "../Language";
import { IDestroyOptions } from "@pixi/display";

export class LocalizedText extends FitText {
    public constructor(
        private readonly key: string,
        private readonly localization: Localization,
        textStyle: TextStyle,
        autoFitWidth: number,
        autoFitHeight: number
    ) {
        super(localization.getText(key), textStyle, autoFitWidth, autoFitHeight);
        this.localization.localeChange.add(this.localizeText, this);
    }

    private localizeText(language: Language): void {
        this.text = this.localization.getText(this.key);
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.localization.localeChange.remove(this.localizeText, this);
        super.destroy(options);
    }
}